// Checkout click
document.querySelector("#cartFooterCheckout")?.addEventListener("click", function () {
    window.location.href = `${Shopify.routes.root}checkout`;
});

// if a removed item is the "purchase" half of a gift group, find its paired "gift" item so it gets removed too
async function getGiftPairKey(key) {
    const cart = await getCart();
    const item = cart.items.find(cartItem => cartItem.key === key);
    if (!item || item.properties?._gift_group !== "purchase") {
        return null;
    }

    // match on _group_id so only the paired gift item is removed, not other gifts
    const giftItem = cart.items.find(cartItem =>
        cartItem.properties?._gift_group === "gift" &&
        cartItem.properties?._group_id === item.properties._group_id
    );

    return giftItem ? giftItem.key : null;
}

// using number input to hit Shopify endpoint
document.querySelectorAll('.cartBodyItemQuantity').forEach(input => {
    input.addEventListener('change', async function () {
        // build the update for this item
        const updates = {
            [this.dataset.key]: this.value,
        };

        // quantity dropping to zero removes the item, so drop its gift pair too
        if (parseInt(this.value, 10) === 0) {
            const giftKey = await getGiftPairKey(this.dataset.key);
            if (giftKey) {
                updates[giftKey] = 0;
            }
        }

        // update cart
        await updateCart({updates});

        // reload page
        window.location.reload();
    })
})

// listen for remove to allow notice on refresh
document.querySelectorAll('.cartBodyItemRemove').forEach(el => {
    el.addEventListener('click', async function () {
        // get item info
        let message = this.dataset.title;
        if (this.dataset.variant) {
            message = `${this.dataset.title} - ${this.dataset.variant}`;
        }
        const deletedItem = {
            quantity: this.dataset.quantity,
            message,
            url: this.dataset.url
        }

        // store item info
        localStorage.setItem("itemDeleted", JSON.stringify(deletedItem));

        // remove this item, plus its gift pair if it has one
        const updates = {
            [this.dataset.key]: 0,
        };
        const giftKey = await getGiftPairKey(this.dataset.key);
        if (giftKey) {
            updates[giftKey] = 0;
        }
        await updateCart({updates});

        // reload page
        window.location.reload();
    })
})

// check if item was deleted or if this is another load. If deleted item, display message in cart
document.addEventListener('DOMContentLoaded', () => {
    let deletedItem = JSON.parse(localStorage.getItem("itemDeleted"));
    if (deletedItem) {
        document.querySelector("#cartBody")?.insertAdjacentHTML("beforebegin", `
            <div id="cartBodyRemove">Removed <span>(${deletedItem.quantity})</span> <a href="${deletedItem.url}">${deletedItem.message}</a> from your cart.</div>`);
        localStorage.removeItem("itemDeleted");
    }
})